<span
    [ngClass]="{
    'bg-green-100 text-green-800': stockLevel === 'IN_STOCK',
    'bg-yellow-100 text-yellow-800': stockLevel === 'LOW_STOCK',
    'bg-red-100 text-red-800': stockLevel === 'OUT_OF_STOCK'
     }"
    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800"
    *ngIf="stockLevel"
>
    {{ stockLevelLabel }}
</span>
